import { render, staticRenderFns } from "./CompanyContact.vue?vue&type=template&id=645ed943&scoped=true&"
import script from "./CompanyContact.vue?vue&type=script&lang=js&"
export * from "./CompanyContact.vue?vue&type=script&lang=js&"
import style0 from "./CompanyContact.vue?vue&type=style&index=0&id=645ed943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ed943",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645ed943')) {
      api.createRecord('645ed943', component.options)
    } else {
      api.reload('645ed943', component.options)
    }
    module.hot.accept("./CompanyContact.vue?vue&type=template&id=645ed943&scoped=true&", function () {
      api.rerender('645ed943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/companies/CompanyContact.vue"
export default component.exports